import { createFileRoute } from '@tanstack/react-router';

import { CameraControlRoute } from '../-cameraControl/CameraControlRoute.tsx';

export const Route = createFileRoute('/(app)/utils/cameraCheck')({
  component: CameraControlRoute,
});
